module.exports = __webpack_public_path__ + "6e91c334bbc4d659b19412aeef096b62.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader!./src/sample-data/brain.json
// module id = 55
// module chunks = 0